module.exports = __webpack_public_path__ + "static/img/photo-6.299320bb.jpg";